module.exports = __webpack_public_path__ + "img/histoires-de-dire.079d6471.png";